import React, { useEffect, useState, Fragment } from 'react'
import injectStyles from 'react-jss'
import { AmbassadorSection } from '../../../../../../Components/City/Page/Ambassador/AmbassadorSection'
import { styles } from './styles'
import ButtonGroup from '@material-ui/core/ButtonGroup'
import SubmitButton from '../../../../../../Components/Form/SubmitButton'
import UserRequestsTable from '../../../../../../Components/UserRequestsTable'
import {
  hideReduxModal,
  showReduxModal,
} from '../../../../../../Reducers/UI/actions'
import { useDispatch } from 'react-redux'
import RejectModalBody from '../../../../../../Components/UserRequestsTable/ActionModals/RejectModalBody'
import ApproveModal from '../../../../../../Components/UserRequestsTable/ActionModals/ApproveModal'
import {
  addCommentGQL,
  addInternalCommentGQL,
  addTimeOffCommentGQL,
  addTimeOffInternalCommentGQL,
  approveRequestGQLById,
  approveTimeOffRequestGQLById,
  getBrandAmbassadorRequestsAndTimeOff,
  rejectRequestGQL,
  rejectTimeOffRequestGQLById,
} from './gql'
import {
  USER_REQUESTS_HEADERS_HISTORY,
  USER_REQUESTS_HEADERS_PENDING,
  VIEW_TYPES,
} from '../../../../../../Components/UserRequestsTable/options'
import {
  formatDataToView,
  formatTimeOffRequestsToView,
} from '../../../../../../Components/UserRequestsTable/utils'
import useGraphQLFetch from '../../../../../../Utils/Hooks/useGraphQLFetch'
import CommentModal from '../../../../../../Components/UserRequestsTable/ActionModals/CommentModal'
import InternalCommentModal from '../../../../../../Components/UserRequestsTable/ActionModals/InternalCommentModal'
import ViewRequestModal from '../../../../../../Components/UserRequestsTable/ActionModals/ViewRequestModal'
import ViewTimeOffRequestModal from '../../../../../../Components/UserRequestsTable/ActionModals/ViewTimeOffRequestModal'
import { HARDCODED_PTO_REQUEST_TYPE } from '../../../../../../constants'

const UserRequestsSection = ({
  ambassador,
  classes,
  documentTypes,
  isDocumentManagementEnabled,
  countryCode,
}) => {
  const [activeView, setActiveView] = useState(VIEW_TYPES.PENDING)
  const [pendingData, setPendingData] = useState([])
  const [historyData, setHistoryData] = useState([])
  const dispatch = useDispatch()

  const defaultFetchArgs = { ambassadorId: ambassador.id }
  const timezone = ambassador.city.timezone

  const { data, isLoading, isLoaded, refetch } = useGraphQLFetch({
    fetchFn: getBrandAmbassadorRequestsAndTimeOff,
    defaultFetchArgs,
    fetchId: 'getBrandAmbassadorRequestsAndTimeOff',
    mapResponse: data => {
      const personalDataChangeRequest =
        data.brandAmbassador.personalDataChangeRequest
      const timeOffRequest = data.brandAmbassador.timeOffRequest
      return [
        ...personalDataChangeRequest,
        ...formatTimeOffRequestsToView(timeOffRequest),
      ]
    },
  })

  const shouldShowSection =
    countryCode == 'DE' ||
    isDocumentManagementEnabled ||
    (data && data.length > 0)

  useEffect(() => {
    if (data && data.length && documentTypes.length && !isLoading) {
      const { pendingData, historyData } = formatDataToView(data, documentTypes)
      setPendingData(pendingData)
      setHistoryData(historyData)
    }
  }, [documentTypes.length, data, isLoading])

  useEffect(() => {
    if (pendingData.length) {
      setActiveView(VIEW_TYPES.PENDING)
    }
    if (!pendingData.length && historyData.length) {
      setActiveView(VIEW_TYPES.HISTORY)
    }
  }, [pendingData.length, historyData.length])

  const openViewModal = data => {
    return dispatch(
      showReduxModal({
        children:
          data.type == HARDCODED_PTO_REQUEST_TYPE ? (
            <ViewTimeOffRequestModal
              requestData={data}
              onClose={() => {
                dispatch(hideReduxModal())
              }}
            />
          ) : (
            <ViewRequestModal
              requestData={data}
              onClose={() => {
                dispatch(hideReduxModal())
              }}
            />
          ),

        onConfirm: () => dispatch(hideReduxModal()),
        hideConfirm: true,
        hideCancel: true,
        hideButtons: true,
        hideTitle: true,
        aspect: 'contract',
      }),
    )
  }

  const onReject = async (data, comment = null) => {
    try {
      if (data.type == HARDCODED_PTO_REQUEST_TYPE) {
        const reject = await rejectTimeOffRequestGQLById({
          id: data.id,
          comment,
        })
        const {
          data: {
            updateTimeOffRequest: { success },
          },
        } = await reject.json()
        if (success) {
          refetch(defaultFetchArgs)
        }
      } else {
        const reject = await rejectRequestGQL({ id: data.id, comment })
        const {
          data: {
            updatePersonalDataChangeRequest: { success },
          },
        } = await reject.json()
        if (success) {
          refetch(defaultFetchArgs)
        }
      }
    } catch (error) {
      console.error({ error })
    }
  }

  const onApprove = async data => {
    try {
      if (data.type == HARDCODED_PTO_REQUEST_TYPE) {
        const response = await approveTimeOffRequestGQLById(data.id)
        const {
          data: {
            updateTimeOffRequest: { success },
          },
        } = await response.json()
        if (success) {
          window.location.reload()
        }
      } else {
        const response = await approveRequestGQLById(data.id)
        const {
          data: {
            updatePersonalDataChangeRequest: { success },
          },
        } = await response.json()
        if (success) {
          window.location.reload()
        }
      }
    } catch (error) {
      console.error({ error })
    }
  }

  const addComment = async (data, comment) => {
    try {
      if (data.type == HARDCODED_PTO_REQUEST_TYPE) {
        const response = await addTimeOffCommentGQL({ id: data.id, comment })
        const {
          data: {
            updateTimeOffRequest: { success },
          },
        } = await response.json()
        if (success) {
          refetch(defaultFetchArgs)
        }
      } else {
        const response = await addCommentGQL({ id: data.id, comment })
        const {
          data: {
            updatePersonalDataChangeRequest: { success },
          },
        } = await response.json()
        if (success) {
          refetch(defaultFetchArgs)
        }
      }
    } catch (error) {
      console.error({ error })
    }
  }

  const addInternalComment = async (data, internalComment) => {
    try {
      if (data.type == HARDCODED_PTO_REQUEST_TYPE) {
        const response = await addTimeOffInternalCommentGQL({
          id: data.id,
          internalComment,
        })
        const {
          data: {
            updateTimeOffRequest: { success },
          },
        } = await response.json()
        if (success) {
          refetch(defaultFetchArgs)
        }
      } else {
        const response = await addInternalCommentGQL({
          id: data.id,
          internalComment,
        })
        const {
          data: {
            updatePersonalDataChangeRequest: { success },
          },
        } = await response.json()
        if (success) {
          refetch(defaultFetchArgs)
        }
      }
    } catch (error) {
      console.error({ error })
    }
  }

  const openRejectModal = data => {
    return dispatch(
      showReduxModal({
        children: <RejectModalBody requestData={data} onReject={onReject} />,
        confirmLabel: 'Cancel',
        hideConfirm: true,
        hideCancel: true,
        hideButtons: true,
        hideTitle: true,
        aspect: 'nonScrollable',
      }),
    )
  }

  const openAddCommentModal = data => {
    return dispatch(
      showReduxModal({
        children: <CommentModal requestData={data} addComment={addComment} />,
        confirmLabel: 'Cancel',
        hideConfirm: true,
        hideCancel: true,
        hideButtons: true,
        hideTitle: true,
        aspect: 'nonScrollable',
      }),
    )
  }
  const openAddInternalCommentModal = data => {
    return dispatch(
      showReduxModal({
        children: (
          <InternalCommentModal
            requestData={data}
            addInternalComment={addInternalComment}
          />
        ),
        confirmLabel: 'Cancel',
        hideConfirm: true,
        hideCancel: true,
        hideButtons: true,
        hideTitle: true,
        aspect: 'nonScrollable',
      }),
    )
  }

  const openApproveModal = data => {
    return dispatch(
      showReduxModal({
        children: <ApproveModal requestData={data} onApprove={onApprove} />,
        confirmLabel: 'Cancel',
        hideConfirm: true,
        hideCancel: true,
        hideButtons: true,
        hideTitle: true,
        aspect: 'nonScrollable',
      }),
    )
  }
  const isPendingView = activeView === VIEW_TYPES.PENDING

  const doesntHaveRequestsInCurrentTab = isPendingView
    ? pendingData.length == 0
    : historyData.length == 0

  if (!shouldShowSection) {
    return null
  }

  return (
    <AmbassadorSection>
      <div className={classes.wrapper}>
        <div className={classes.title}>BA requests</div>
        {isLoaded && (
          <Fragment>
            <div className="type-buttons">
              <ButtonGroup disableElevation color="primary">
                <SubmitButton
                  value="Pending"
                  variant={
                    activeView === VIEW_TYPES.PENDING ? 'contained' : 'outlined'
                  }
                  onClick={() => setActiveView(VIEW_TYPES.PENDING)}
                />
                <SubmitButton
                  value="History"
                  variant={
                    activeView === VIEW_TYPES.HISTORY ? 'contained' : 'outlined'
                  }
                  onClick={() => setActiveView(VIEW_TYPES.HISTORY)}
                />
              </ButtonGroup>
            </div>
            {doesntHaveRequestsInCurrentTab ? (
              <div className={classes.noRequestText}>
                There are no requests from this BA yet
              </div>
            ) : (
              <UserRequestsTable
                headers={
                  isPendingView
                    ? USER_REQUESTS_HEADERS_PENDING
                    : USER_REQUESTS_HEADERS_HISTORY
                }
                data={isPendingView ? pendingData : historyData}
                openViewModal={openViewModal}
                openRejectModal={openRejectModal}
                openApproveModal={openApproveModal}
                activeView={activeView}
                isLoading={isLoading}
                openAddCommentModal={openAddCommentModal}
                openAddInternalCommentModal={openAddInternalCommentModal}
                timezone={timezone}
              />
            )}
          </Fragment>
        )}
      </div>
    </AmbassadorSection>
  )
}

export default injectStyles(styles)(UserRequestsSection)
